export default __webpack_public_path__ + "static/left-quote-c6f393864ca05d456afe2fbcce71a2e4.png";